import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer';  
import LazyLoad from "react-lazyload";  
const SpecialFeatures = () => {  
  useEffect(() => {
    document.title = 'Special Features - St. Francis Xavier School';  
}, []); 
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>Prospectus</li>
                    <li>Special Features</li>
                </ul>
            </div> 
            <section className="innerbody innerimgdec">
            <div className="container"> 
                    <div className="row"> 
                    <div className="col-lg-12">
                    <ul className="mainlist">
                    <li>Close circuit T.V. cameras for effective monitoring</li>
                    <li>Well-ventilated air-cooled specially designed classrooms as per the norms of the CBSE.
                    </li>
                    <li>Vast playfields for physical growth, as it is said: "A healthy mind dwells in a healthy
                        body."
                    </li>
                    <li>Safe cold water for drinking</li>
                    <li>Separate toilets for boys and girls.</li>
                    <li>For updating the knowledge of current affairs, special emphasis on newspapers,
                        magazines, and
                        periodical reading.</li>
                    <li>For maximum exposure, debates, group discussions, speeches, quizzes, etc., will be
                        organized
                        regularly.</li>
                </ul>
                     </div>
                     <div className="row">
                        <div className="col-xl-3  col-lg-4 col-md-6 col-12">
                            <LazyLoad>
                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Special_Features_1.jpg" className="img-fluid" alt="sfxhisar"/>
                            </LazyLoad>
                        </div>
                        <div className="col-xl-3  col-lg-4 col-md-6 col-12">
                            <LazyLoad>
                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Special_Features_2.jpg" className="img-fluid" alt="sfxhisar"/>
                            </LazyLoad>
                        </div>
                        <div className="col-xl-3  col-lg-4 col-md-6 col-12">
                            <LazyLoad>
                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Special_Features_3.jpg" className="img-fluid" alt="sfxhisar"/>
                            </LazyLoad>
                        </div>
                        <div className="col-xl-3  col-lg-4 col-md-6 col-12">
                            <LazyLoad>
                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Special_Features_4.jpg" className="img-fluid" alt="sfxhisar"/>
                            </LazyLoad>
                        </div>
                        <div className="col-xl-3  col-lg-4 col-md-6 col-12">
                            <LazyLoad>
                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Special_Features_5.jpg" className="img-fluid" alt="sfxhisar"/>
                            </LazyLoad>
                        </div>
                        <div className="col-xl-3  col-lg-4 col-md-6 col-12">
                            <LazyLoad>
                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Special_Features_6.jpg" className="img-fluid" alt="sfxhisar"/>
                            </LazyLoad>
                        </div>
                        <div className="col-xl-3  col-lg-4 col-md-6 col-12">
                            <LazyLoad>
                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Special_Features_7.jpg" className="img-fluid" alt="sfxhisar"/>
                            </LazyLoad>
                        </div>
                        </div>
                    </div>
                    </div>  
           </section>
           <Footer/>
        </>
    );
}

export default SpecialFeatures;
